<template>
    <div class="segment">
        <b-pagination
            :value="value"
            :total-rows="rows"
            :per-page="sharedState.perPage.data"
            :limit="pageLimit"
            @input="onInput"
            align="center"
            class="mt-2"
        >
        </b-pagination>
        <div v-for="item in audioItems" v-bind:key="item.key">
            <div class="mb-2">
                <audio-buttons-title :item="item"> </audio-buttons-title>
                <audio-buttons
                    :audio-items="item.items"
                    :button-type="buttonType"
                ></audio-buttons>
            </div>
        </div>
        <b-pagination
            :value="value"
            :total-rows="rows"
            :per-page="sharedState.perPage.data"
            :limit="pageLimit"
            @input="onInput"
            align="center"
        >
        </b-pagination>
    </div>
</template>

<script>
import AudioButtons from '@/components/AudioButtons.vue'
import AudioButtonsTitle from '@/components/AudioButtonsTitle.vue'
import store from '../store/store'

export default {
    name: 'AudioButtonsSegment',
    components: {
        AudioButtons,
        AudioButtonsTitle,
    },
    data: function () {
        return {
            sharedState: store.state,
            pageLimit: 10,
        }
    },
    methods: {
        onInput : function(page) {
            this.$emit('input', page)
        }
    },
    props: {
        value: {
            type: Number
        },
        audioItems: {
            type: Array,
        },
        audioItemsArray: {
            type: Array,
        },
        buttonType: {
            type: String,
        },
    },
    computed: {
        rows: function () {
            return this.audioItemsArray.length
        },
        buttonClass: function () {
            switch (this.buttonType) {
                case 'normal':
                    return 'normalbutton'
                case 'mini':
                    return 'minibutton'
                default:
                    return 'normalbutton'
            }
        },
    },
}
</script>

<style scoped>
.segment {
    background-color: rgba(20, 20, 20, 1);
    border: solid;
    border-radius: 1rem;
    box-shadow: 0px 0px 5px 1px rgb(237 177 237 / 50%);
    border-width: 2px;
}
.title {
    font-size: medium;
    padding: 1rem 2rem;
    border-left: 5px solid #000;
    background: #f4f4f4;
}
</style>

<style>
.segment .page-item.active .page-link {
    color: #000;
    background-color: #d6b6d8;
    border: none;
}
.segment .page-item.disabled .page-link {
    color: #fff;
    background-color: #292929;
    border: none;
}
.segment .page-item .page-link {
    color: #fff;
    background-color: #292929;
    border: none;
}
</style>
